import PropTypes from 'prop-types';
import './Skeleton.css';

export function Skeleton({ width, height, className = '', variant = 'text' }) {
    return (
        <div
            className={`skeleton skeleton-${variant} ${className}`}
            style={{ width, height }}
        />
    );
}

export function SkeletonText({ lines = 3, className = '' }) {
    return (
        <div className={`skeleton-text ${className}`}>
            {Array.from({ length: lines }).map((_, i) => (
                <Skeleton
                    key={i}
                    variant="text"
                    width={i === lines - 1 ? '60%' : '100%'}
                />
            ))}
        </div>
    );
}

export function SkeletonCard({ className = '' }) {
    return (
        <div className={`skeleton-card ${className}`}>
            <Skeleton variant="rectangular" height={120} />
            <div className="skeleton-card-content">
                <Skeleton variant="text" width="80%" />
                <Skeleton variant="text" width="60%" />
            </div>
        </div>
    );
}

export function SkeletonTable({ rows = 5, columns = 4, className = '' }) {
    return (
        <div className={`skeleton-table ${className}`}>
            <div className="skeleton-table-header">
                {Array.from({ length: columns }).map((_, i) => (
                    <Skeleton key={i} variant="text" width="80px" />
                ))}
            </div>
            {Array.from({ length: rows }).map((_, rowIdx) => (
                <div key={rowIdx} className="skeleton-table-row">
                    {Array.from({ length: columns }).map((_, colIdx) => (
                        <Skeleton key={colIdx} variant="text" />
                    ))}
                </div>
            ))}
        </div>
    );
}

Skeleton.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    variant: PropTypes.oneOf(['text', 'circular', 'rectangular'])
};

SkeletonText.propTypes = {
    lines: PropTypes.number,
    className: PropTypes.string
};

SkeletonCard.propTypes = { className: PropTypes.string };
SkeletonTable.propTypes = {
    rows: PropTypes.number,
    columns: PropTypes.number,
    className: PropTypes.string
};

export default Skeleton;
